require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicalnewstoday-symptoms.json") })
        }
      }, "path---article-medicalnewstoday-symptoms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicalnewstoday-symptoms!./.cache/json/article-medicalnewstoday-symptoms.json
// module id = 352
// module chunks = 231608221292675